// extracted by mini-css-extract-plugin
export default {"tile":"tile_FmJxpsG","tileTitle":"tileTitle_Zq0LkbZ","tileType":"tileType_Rt4WqnZ"};